<!-- 查询月卡信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","carNO":"粤Z12345","cusNO":""},
            responseCode: 	{"data":{"monthCardList":[{"address":"","carCodes":"粤Z12345,粤Y12345","carNO":"粤Z12345,粤Y12345","carportList":[],"company":"","cusNO":"老祁","department":"","monthCardName":"月卡VIP","phone":"13655545425","remark1":"","remark2":"","remark3":"","room":"","settlementType":0,"settlementValue":300,"ticketNo":"3","timePeriodList":[{"endTime":"20171001235959","startTime":"20161201000000"}],"validStatus":1},{"address":"","carCodes":"粤Z12345,粤Y12345","carNO":"粤Z12345,粤Y12345","carportList":[],"company":"","cusNO":"老祁","department":"","monthCardName":"月卡VIP","phone":"13655545425","remark1":"","remark2":"","remark3":"","room":"","settlementType":0,"settlementValue":300,"ticketNo":"6","timePeriodList":[{"endTime":"20181001235959","startTime":"20171202000000"}],"validStatus":2}],"total":2},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取某个车主或某个车辆月卡信息",
                t_url: this.commonUrls.test+"getMonthCard",
                p_url: this.commonUrls.prod+"getMonthCard",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'cusNO', info2: '否', info3: 'String', info4: '车主名（车主名和车牌号可都填，可选填，建议至少一个有值）' },
                        { info1: 'carNO', info2: '否', info3: 'String', info4: '车牌号（车主名和车牌号可都填，可选填，建议至少一个有值）' },
                        { info1: 'ticketNo', info2: '否', info3: 'String', info4: '外部平台对票的唯一值' },
                        { info1: 'tel', info2: '否', info3: 'String', info4: '车主手机号' },
                        { info1: 'carport', info2: '否', info3: 'String', info4: '车位编号' },
                        { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始（VEMS4.12之后支持）' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条（VEMS4.12之后支持）' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总条数' },
                        { info1: 'currCount', info2: '否', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'monthCardList', info2: '是', info3: 'JSONArray', info4: '月卡记录列表' }
                        ]
                },{
                    titleName: 'monthCardList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ticketNo', info2: '是', info3: 'String', info4: '月卡唯一编号' },
                        { info1: 'cusNO', info2: '是', info3: 'String', info4: '车主名' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'address', info2: '是', info3: 'String', info4: '车主地址' },
                        { info1: 'company', info2: '是', info3: 'String', info4: '公司' },
                        { info1: 'department', info2: '是', info3: 'String', info4: '部门' },
                        { info1: 'room', info2: '是', info3: 'String', info4: '房间号' },
                        { info1: 'remark1', info2: '是', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '是', info3: 'String', info4: '备注2' },
                        { info1: 'remark3', info2: '是', info3: 'String', info4: '备注3' },
                        { info1: 'carNO', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'monthCardName', info2: '是', info3: 'String', info4: '月卡名称' },
                        { info1: 'settlementValue', info2: '是', info3: 'Decimal', info4: '结算类型为0则为月卡单价，结算类型为1则为余额，结算类型为2则为剩余次数' },
                        { info1: 'validStatus', info2: '是', info3: 'Integer', info4: '月卡有效状态，0已过期，1生效中，2待生效，3已退款' },
                        { info1: 'settlementType', info2: '是', info3: 'Integer', info4: '0时间结算，1余额结算，2次数结算' },
                        { info1: 'carCodes', info2: '是', info3: 'String', info4: '车牌号码,多个采用英文逗号分隔' },
                        { info1: 'carportList', info2: '否', info3: 'JSONArray', info4: '车位列表' },
                        { info1: 'timePeriodList', info2: '是', info3: 'JSONArray', info4: '有效时段列表' }
                        ]
                },{
                    titleName: 'carportList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingLotId', info2: '是', info3: 'String', info4: '所属停车场编号' },
                        { info1: 'carportSerialNumber', info2: '是', info3: 'String', info4: '车位编号' },
                        { info1: 'carportAlaisName', info2: '是', info3: 'String', info4: '车位别名' },
                        { info1: 'carportType', info2: '是', info3: 'int', info4: '车位类型，0未指定,1固定车位,2临时车位,3租用车位' },
                        { info1: 'isOpenReserved', info2: '是', info3: 'int', info4: '是否开启预订（0否，1是）' }
                        ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyyMMddHHmmss' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/vip/getMonthCard.vue